import { render } from "./_SurveyServices.vue?vue&type=template&id=563f3ed0&scoped=true&lang=en"
import script from "./_SurveyServices.vue?vue&type=script&lang=js"
export * from "./_SurveyServices.vue?vue&type=script&lang=js"

import "./_SurveyServices.vue?vue&type=style&index=0&id=563f3ed0&lang=scss&scoped=true"

import exportComponent from "/usr/local/var/www/website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-563f3ed0"]])

export default __exports__